import React, { useEffect, useState } from 'react';

/**
 * CrayolaTalep: Crayola'nın dünya ve Türkiye talep röntgeni.
 * Route: /reports/crayola (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 20 slayt, 16:9, apple.com tasarım dili. Learning Resources hattıyla aynı
 * kurgudan üretiliyor. Yeniden üretmek için:
 *   node src/pages/crayola/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~109KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function CrayolaTalep() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('../crayolaHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Crayola · Talep Röntgeni"
      srcDoc={html}
      style={fill}
    />
  );
}
